import * as React from 'react';

// tslint:disable:max-line-length
export const ArrowLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12">
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M6.81 1.954L2.763 6l4.047 4.047a1.144 1.144 0 0 1-1.619 1.617L.336 6.81a1.144 1.144 0 0 1 0-1.619L5.19.335A1.146 1.146 0 0 1 6.81 1.954z"
    />
  </svg>
);
